import Swal from 'sweetalert2';
import { IParametro } from "../interfaces/IParametro";
import api from "./Api";

class ParametrizacaoService {

  async obterTodos(funcaoSucesso?: (data: IParametro[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get<IParametro[]>('Parametrizacao');

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async obterPorId(id: number, funcaoSucesso?: (data: IParametro) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get<IParametro>(`Parametrizacao/${id}`);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async criar(parametro: IParametro, funcaoSucesso?: (data: IParametro) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.post('Parametrizacao', parametro);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {

      const { errors = null } = error.message;
      let message: any = "";
      console.log(error);
      if (errors) {
        const arrayErrors = Object.values(errors);
        arrayErrors.forEach((item) => {
          message += " " + item
        });
      }

      Swal.fire({
        text: message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async atualizar(parametro: IParametro, funcaoSucesso?: (data: IParametro) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.put(`Parametrizacao/${parametro.id}`, parametro);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async excluir(id: number, funcaoSucesso?: () => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      await api.delete(`Parametrizacao/${id}`);

      funcaoSucesso && funcaoSucesso();

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async manutencaoTodos(cardId: number): Promise<boolean> {
    try {
      await api.patch(`Conciliation/card/${cardId}/refuse/all`);
      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async desvincular(cardId: number, chaveVinculo: string): Promise<boolean> {
    try {
      await api.patch(`Conciliation/card/${cardId}/refuse/guid/${chaveVinculo}`);
      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async vincularMatch(cardId: number, chaveVinculo: string): Promise<boolean> {
    try {
      await api.patch(`Conciliation/card/${cardId}/accept/match/${chaveVinculo}`);
      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async desvincularMatch(cardId: number, chaveVinculo: string): Promise<boolean> {
    try {
      await api.patch(`conciliation/card/${cardId}/refuse/match/${chaveVinculo}`);
      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async desvincularItem(cardId: number, id: number): Promise<boolean> {
    try {
      await api.patch(`Conciliation/card/${cardId}/refuse/id/${id}`);
      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async desvincularItemMatch(cardId: number, lancamentoId: number): Promise<boolean> {
    try {
      await api.patch(`Conciliation/card/${cardId}/refuse/match/lancamento/${lancamentoId}`);
      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }
}

export default new ParametrizacaoService();